import { render, staticRenderFns } from "./titleInfo.vue?vue&type=template&id=57641e13&scoped=true&"
import script from "./titleInfo.vue?vue&type=script&lang=js&"
export * from "./titleInfo.vue?vue&type=script&lang=js&"
import style0 from "./titleInfo.vue?vue&type=style&index=0&id=57641e13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57641e13",
  null
  
)

export default component.exports